import IndexView from '@/views/IndexView.vue'

// 一级页面
const firstPages = [
    {
        path: '/index1',
        name: 'index1',
        meta: { breadcrumb: '首页' },
        component: () => import(/* webpackChunkName: "about" */ '@/views/pages/IndexView.vue')
    }, {
        path: '/',
        name: 'index',
        meta: { breadcrumb: '首页' },
        component: IndexView
    }, {
        path: '/login',
        name: 'login',
        meta: { breadcrumb: '登录' },
        component: () => import(/* webpackChunkName: "about" */ '@/views/first/LoginView.vue')
    }, {
        path: '/smsLogin',
        name: 'smsLogin',
        meta: { breadcrumb: '验证码登录' },
        component: () => import(/* webpackChunkName: "about" */ '@/views/first/SmsLoginView.vue')
    }, {
        path: '/forgePassword',
        name: 'forgePassword',
        meta: { breadcrumb: '忘记密码' },
        component: () => import(/* webpackChunkName: "about" */ '@/views/first/ForgePasswordView.vue')
    }, {
        path: '/regist',
        name: 'regist',
        meta: { breadcrumb: '注册' },
        component: () => import(/* webpackChunkName: "about" */ '@/views/first/RegistView.vue')
    }, {
        path: '/about',
        name: 'about',
        meta: { breadcrumb: '关于我们' },
        component: () => import(/* webpackChunkName: "about" */ '@/views/first/AboutView.vue')
    }, {
        path: '/news',
        name: 'news',
        meta: { breadcrumb: '新闻中心' },
        component: () => import('@/views/first/NewsView.vue')
    }, {
        path: '/course',
        name: 'course',
        meta: { breadcrumb: '课程中心' },
        component: () => import('@/views/first/CourseView.vue')
    }, {
        path: '/learning',
        name: 'learning',
        meta: { breadcrumb: '学习中心', requiresAuth: true },
        component: () => import('@/views/learning/LearningView.vue')
    }, {
        path: '/database',
        name: 'database',
        meta: { breadcrumb: '资料库' },
        component: () => import('@/views/first/DatabaseView.vue')
    }, {
        path: '/credit/:userId/:classId',
        name: 'credit',
        meta: { breadcrumb: '' },
        component: () => import(/* webpackChunkName: "about" */ '@/views/first/CreditView.vue')
    }
]
export default firstPages